const authStatus = state => {
  state.userLogged = !state.userLogged;
};

const confirmed = (state, val) => {
  state.confirmed = val;
};

const resetConfirmed = state => {
  state.confirmed = false;
};

export { authStatus, confirmed, resetConfirmed };
